import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Button from '../Button';
import s from './SaveChangesButton.css';
import Messages from './Messages';

class SaveChangesButton extends React.Component {
  render() {
    const { devicetype } = this.props;
    const isSuperior = devicetype === 'superior';
    const lightColor = isSuperior ? 'light_spirotech' : 'light';
    const colorStyled = isSuperior ? cx(s.black_text) : cx(s.superior_text);
    const messages = Messages();
    return (
      <Button 
        buttonColor={lightColor} 
        onClick={this.props.onClick}
        type="submit"
        block>
        <div className={colorStyled}>
          <FormattedMessage
            {...messages.save_changes_button_main_screen_text}
          />
        </div>
      </Button>
    );
  }
}

SaveChangesButton.propTypes = {
  intl: intlShape.isRequired,
  devicetype: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

SaveChangesButton.defaultProps = {
  devicetype: '',
};

export default injectIntl(withStyles(s)(SaveChangesButton));



// WEBPACK FOOTER //
// ./src/components/SaveChangeButtonPopup/SaveChangesButton.js